import BModal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";


const AlertModal = ({ show, onHide, count, updatecount }) => {
    return (
      <BModal centered show={show} onHide={onHide}>
        <div>
          <p
            style={{
              fontSize: "large",
              lineHeight: "24px",
              fontWeight: "600",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            {updatecount === 2
              ? "Please answer 2 questions"
              : count === 2
                ? "Please answer 2 questions"
                : updatecount === 1 && count === 1
                  ? "Since only two prompts can be answered, and one has already been submitted for review. You'll receive an update within 24 hours."
                  : "Answer at least 2 prompts."}
            { }
          </p>
        </div>
        <Button
          style={{
            backgroundColor: "white",
            borderColor: "#6c6c6c",
            borderRadius: "9999px",
            padding: "0.5rem 1rem",
            color: "#6c6c6c",
            fontWeight: "600",
            margin: "1rem auto",
            width: "50%",
          }}
          onClick={() => {
            onHide();
          }}
        >
          Okay
        </Button>
      </BModal>
    );
  }

  export default  AlertModal